export default class AddonsModule {

    addons = [];
    currency = null;
    container = null;
    calculator = null;
    initialData = null;

    constructor(addons, currency, initialData) {
        this.addons = addons;
        this.currency = currency;
        this.container = document.querySelector('.apartment-reservation__services');
        this.initialData = initialData;
        this.prepareAddons();
    }

    setCalculator = (calculator) => {
        this.calculator = calculator;
        this.bindEvent();
    }
    prepareAddons = () => {
        if (this.addons.length === 0) {
            this.container.classList.add('d-none');
        } else {
            this.addons.forEach(addon => {
                const item = document.createElement('div');
                item.classList.add('service-item');
                item.dataset.id = addon.id;
                item.dataset.clicked = false;
                item.dataset.data = JSON.stringify(addon);

                const inputLabel = document.createElement('label');
                inputLabel.classList.add('service-item__checkbox');

                const input = document.createElement('input');
                input.type = "checkbox";

                const itemDots = document.createElement('div');
                itemDots.classList.add('service-item__dots');

                const itemValue = document.createElement('div');
                itemValue.classList.add('service-item__value');

                inputLabel.appendChild(input);

                const p = document.createElement('p');

                const span1 = document.createElement('span');
                span1.innerHTML = addon.name;
                p.appendChild(span1);

                if (addon.isPerNight) {
                    let dtFrom = "";
                    let dtTo = "";
                    dtFrom = addon.dateFrom;
                    dtFrom = ("0" + dtFrom.getDate()).slice(-2) + "-" + ("0" + (dtFrom.getMonth() + 1)).slice(-2) + "-" + dtFrom.getFullYear();
                    dtTo = addon.dateTo;
                    dtTo = ("0" + dtTo.getDate()).slice(-2) + "-" + ("0" + (dtTo.getMonth() + 1)).slice(-2) + "-" + dtTo.getFullYear();

                    const span2 = document.createElement('span');
                    span2.innerHTML += `${dtFrom} - ${dtTo}`;
                    p.appendChild(span2);
                }
                inputLabel.appendChild(p);

                itemValue.innerText = `${addon.value} ${this.currency}`;
                if (this.initialData.langPrefix == 'cs' && this.initialData.cZKCurrencyRate > 0) {
                    itemValue.innerText = `${addon.value} ${this.currency}`
                        + ` (~` + `${this.formatValue(addon.value / this.initialData.cZKCurrencyRate)}` + ` CZK)`;
                }

                item.appendChild(inputLabel);
                item.appendChild(itemDots);
                item.appendChild(itemValue);
                this.container.appendChild(item);
            });
        }     
    }

    bindEvent = () => {
        const addons = document.querySelectorAll('.service-item__checkbox input[type="checkbox"]');
        const parent = this;
        addons.forEach(addon => {
            addon.addEventListener('change', () => {
                const data = JSON.parse(addon.parentElement.parentElement.dataset.data);
                if (addon.checked) {
                    parent.calculator.setCalculationItem(data);
                } else {
                    parent.calculator.setCalculationItem(data, true);
                }
                parent.calculator.renderRentItems();
            });
        })
    }

    formatValue = (value) => {
        return value.toFixed(2).replace('.', ',');
    }
}